import React from 'react'

function Social() {
  return (
    <div className="gitIcon">
        <a href="https://github.com/furkanislek" rel='noreferrer' target="_blank" className='icons'  >
            <i className="fa-brands fa-github " ></i>
        </a>
        <a href="https://www.linkedin.com/in/furkanislek/" rel='noreferrer' target="_blank" className='icons' >
        <i className="fa-brands fa-linkedin"></i>
        </a>
    </div>

  )
}

export default Social